import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { PaginatedRepository } from '../../services/pagination/paginated.repository';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';

import { TaxRate } from '../../interfaces/tax-rates/tax-rate';

@Injectable({
    providedIn: 'root'
})
export class TaxRatesRepositoryService extends PaginatedRepository<TaxRate> {
    protected override _baseLink: string;

    constructor(
      http: HttpClient,
      messageService: ToastrService,
      @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
      super(
          http,
          messageService);
    
          this._currentParams = new HttpParams()
            .set('pageSize', 10);
            
          this._baseLink = `${this.config.rootUrl}/TaxRates`;
      }
}